import { tns } from '../../node_modules/tiny-slider/src/tiny-slider'

// Slider for component hero
const elementsHero = document.querySelectorAll('.o-hero.--slider ')
if (elementsHero.length > 0) {
  for (const element of elementsHero) {
    const slider = tns({
      container: element.querySelector('.medias .items'),
      items: 1,
      prevButton: element.querySelector('.controls .prev'),
      nextButton: element.querySelector('.controls .next'),
      navContainer: element.querySelector('.nav'),
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
      autoplayButtonOutput: false,
      mouseDrag: true,
    })
    slider.events.on('dragStart', () => slider.pause())
    slider.events.on('dragMove', () => slider.pause())
    slider.events.on('dragEnd', () => slider.pause())
  }
}

// Slider for component text media
const elementsTextMedia = document.querySelectorAll('.n-text-media.--slider')
if (elementsTextMedia.length > 0) {
  for (const element of elementsTextMedia) {
    const slider = tns({
      container: element.querySelector('.list'),
      items: 1,
      prevButton: element.querySelector('.controls .prev'),
      nextButton: element.querySelector('.controls .next'),
      navContainer: element.querySelector('.nav'),
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
      autoplayButtonOutput: false,
      mouseDrag: true,
    })
    slider.events.on('dragStart', () => slider.pause())
    slider.events.on('dragMove', () => slider.pause())
    slider.events.on('dragEnd', () => slider.pause())
  }
}

// Slider for component medias
const elementsMedias = document.querySelectorAll('.n-medias.--slider')
if (elementsMedias.length > 0) {
  for (const element of elementsMedias) {
    const slider = tns({
      container: element.querySelector('.list'),
      items: 1,
      prevButton: element.querySelector('.controls .prev'),
      nextButton: element.querySelector('.controls .next'),
      navContainer: element.querySelector('.nav'),
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
      autoplayButtonOutput: false,
      mouseDrag: true,
    })
    slider.events.on('dragStart', () => slider.pause())
    slider.events.on('dragMove', () => slider.pause())
    slider.events.on('dragEnd', () => slider.pause())
  }
}

// Slider for component manual-content
const elementsManual = document.querySelectorAll('.n-manual-content.--slider')
if (elementsManual.length > 0) {
  for (const element of elementsManual) {
    const slider = tns({
      container: element.querySelector('.list'),
      items: 1,
      prevButton: element.querySelector('.controls .prev'),
      nextButton: element.querySelector('.controls .next'),
      navContainer: element.querySelector('.nav'),
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
      autoplayButtonOutput: false,
      mouseDrag: true,
    })
    slider.events.on('dragStart', () => slider.pause())
    slider.events.on('dragMove', () => slider.pause())
    slider.events.on('dragEnd', () => slider.pause())
  }
}
